import { Button } from '@/components/ui/button';
import { ButtonGroup } from '@/components/ui/button-group';
import type { AdminUserLandingsSubTab } from '@/entities/admin-user.entity';
import { useState } from 'react';
import LandingsDomainsSubtab from './landings-domains-subtab';
import LandingsLinksSubtab from './landings-links-subtab';
import LandingsSitesSubtab from './landings-sites-subtab';
import LandingsStatsSubtab from './landings-stats-subtab';

const SUB_TABS: { id: AdminUserLandingsSubTab; label: string }[] = [
	{ id: 'domains', label: 'Домены' },
	{ id: 'sites', label: 'Сайты' },
	{ id: 'links', label: 'Ссылки' },
	{ id: 'stats', label: 'Статистика' },
];

interface LandingsTabProps {
	profileId: number;
	fetchDomains?: (profileId: number) => Promise<import('@/entities/landing.entity').ILandingDomain[]>;
	fetchSites?: (profileId: number) => Promise<import('@/entities/landing.entity').ILandingSite[]>;
	fetchLinks?: (
		profileId: number,
		params?: { siteId?: number; cursor?: string; limit?: number },
	) => Promise<{ items: import('@/entities/landing.entity').ILandingLink[]; nextCursor?: string | null }>;
	fetchStats?: (
		profileId: number,
		params?: { period?: import('@/entities/admin-stats.entity').StatsPeriod; linkId?: string },
	) => Promise<import('@/entities/landing.entity').ILandingEventStats>;
}

export default function LandingsTab({ profileId, fetchDomains, fetchSites, fetchLinks, fetchStats }: LandingsTabProps) {
	const [subTab, setSubTab] = useState<AdminUserLandingsSubTab>('domains');

	return (
		<div className='flex flex-col gap-3'>
			<div className='flex gap-1.5 overflow-x-auto pb-1'>
				<ButtonGroup className='shrink-0'>
					{SUB_TABS.map(tab => (
						<Button
							key={tab.id}
							size='sm'
							variant={subTab === tab.id ? 'secondary' : 'outline'}
							onClick={() => setSubTab(tab.id)}
						>
							{tab.label}
						</Button>
					))}
				</ButtonGroup>
			</div>

			{subTab === 'domains' && <LandingsDomainsSubtab profileId={profileId} fetchDomains={fetchDomains} />}
			{subTab === 'sites' && <LandingsSitesSubtab profileId={profileId} fetchSites={fetchSites} />}
			{subTab === 'links' && <LandingsLinksSubtab profileId={profileId} fetchLinks={fetchLinks} />}
			{subTab === 'stats' && <LandingsStatsSubtab profileId={profileId} fetchStats={fetchStats} />}
		</div>
	);
}
